<template>
    <v-flex xs12 mb-4 pt-4 id="carousel">
        <v-toolbar text>
            <v-toolbar-title>Слайдер в топе</v-toolbar-title>
            <v-spacer/>
            <v-btn icon text>
                <v-switch v-model="carousel.status"/>
            </v-btn>
        </v-toolbar>
        <v-layout flex wrap v-if="carousel.status">
            <v-flex xs4 v-for="(item, index) in carousel.items" :key="item.id" class="carousel-item"
                    v-if="carousel.items.length">
                <div @click="editCarousel(index)" class="addCarousel">
                    <img :src="rootURL + item.img" alt="" class="carousel-img"/>
                </div>
            </v-flex>
            <v-flex xs4 v-if="carousel.items.length < 6" class="carousel-item">
                <div @click="dialogCreate = true" class="addCarousel">
                    <img src="/static/img/media/carousel_blank.svg" alt=""/>
                </div>
            </v-flex>
            <Add :on-close="closeDialog" :dialog-create="dialogCreate"/>
            <Edit :on-close="closeDialog" :dialog-edit="dialogEdit" :slide="slide"/>
        </v-layout>
    </v-flex>
</template>

<script>
    import config from '../../../config'
    import Add from './Add'
    import Edit from './Edit'

    export default {
        name: 'carouselSite',
        props: ['carousel', 'refreshCarousel'],
        components: {
            Add,
            Edit
        },
        data: () => ({
            slide: {},
            rootURL: '',
            dialogCreate: false,
            dialogEdit: false
        }),
        created () {
            this.rootURL = config.rootPath
        },
        methods: {
            closeDialog: function () {
                this.dialogCreate = false
                this.dialogEdit = false
                this.slide = {}
                this.refreshCarousel()
            },
            editCarousel (index) {
                this.slide = this.carousel.items[index]
                this.dialogEdit = true
            }
        }
    }
</script>
